module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAVlJREFUOI3Fkj8vQ3EUhp9z700Q0T+hqVoMvoLBYJFgEfEdyihSm42wGEj5BGI0UCuViFgMZlsnIiEtOjRSvddraHGbK2nE4Gy/J2+e35uTA38c+5EW8zmwFYM0gFAZ2SbTue3OgvOtAXzvEdMq4rIVGwfWMS/F5GIlHPciAt/JGJhcd4+JpTsATrZL5rgbCoIM0CZoNiju7CMNt0ivYaOCK6R6k1mXwZjQNaLWypWYWp5vNpD0pRQ1oYu2VlJd0M4wa9/B+ZpHkOhnMvcAwNlOmqehMqkbi3D3pcLEmg/gfAkayQXEcajJMcn7LI3EPFIh1KZAEM9Gl2jqQ+oLdYwhYhgOIhYSx+D77fDH+X9B9JC+pw7mYxLC/70g0Aye94ZbrhL0n3YWmN0CIxR35+C9CoAa4MfB8aGYHwQnDhrBuI0KEt2HPL/OIh2YWddPv6l52gWSPUef7ANuNIFPOwntHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete-icon.png
// module id = 1054
// module chunks = 1